import { useContext } from 'react';

import ConfirmModalContext from 'app/components/Modal/ConfirmModalContext';

const useConfirmModal = () => {
  const {
    showConfirmModal
  } = useContext(ConfirmModalContext);

  return {
    showConfirmModal
  }
}

export default useConfirmModal;
